(function () {
  if (window.__VAVOOM_RECOMMENDED_CARD_SWATCHES_PRODUCT_PAGE_ONLY_V72__) return;
  window.__VAVOOM_RECOMMENDED_CARD_SWATCHES_PRODUCT_PAGE_ONLY_V72__ = true;

  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return MOBILE_QUERY.matches;
  }

  function isElement(el) {
    return el && el instanceof Element;
  }

  function isBadArea(el) {
    if (!isElement(el)) return true;

    return !!(
      el.closest('header') ||
      el.closest('.header') ||
      el.closest('[class*="header"]') ||
      el.closest('nav') ||
      el.closest('footer') ||
      el.closest('.footer') ||
      el.closest('[class*="footer"]') ||
      el.closest('.announcement-bar') ||
      el.closest('[class*="announcement"]') ||
      el.closest('form[action*="/cart/add"]')
    );
  }

  function isRecommendedArea(el) {
    if (!isElement(el) || isBadArea(el)) return false;

    return !!(
      el.closest('[data-product-recommendations]') ||
      el.closest('product-recommendations') ||
      el.closest('.product-recommendations') ||
      el.closest('[id*="recommend"]') ||
      el.closest('[class*="recommend"]') ||
      el.closest('[id*="Recommended"]') ||
      el.closest('[class*="Recommended"]') ||
      el.closest('[class*="similar"]') ||
      el.closest('[class*="Similar"]')
    );
  }

  function renameLimitedEditionBadges(scope) {
    var container = scope || document;

    container.querySelectorAll('.pc-limited-edition-badge').forEach(function (badge) {
      badge.textContent = 'NEW';
    });
  }

  function getOuterProductCard(el) {
    if (!isElement(el) || isBadArea(el)) return null;

    var card = el.closest('product-card');

    if (card && !isBadArea(card) && card.querySelector('.pc-color-squares')) {
      return card;
    }

    var node = el;

    while (node && node !== document.body) {
      if (isBadArea(node)) return null;

      if (node.querySelectorAll) {
        var groups = node.querySelectorAll('.pc-color-squares');
        var images = node.querySelectorAll('img');
        var links = node.querySelectorAll('a[href*="/products/"], .product-card__link, [ref="productCardLink"], [ref="cardGalleryLink"]');

        if (groups.length === 1 && images.length > 0 && links.length > 0) {
          return node;
        }
      }

      node = node.parentElement;
    }

    return null;
  }

  function getCardFromButton(button) {
    if (!isElement(button) || isBadArea(button)) return null;

    var group = button.closest('.pc-color-squares');
    if (!group || !isRecommendedArea(group)) return null;

    return getOuterProductCard(group);
  }

  function getCardFromTarget(target) {
    if (!isElement(target) || isBadArea(target) || !isRecommendedArea(target)) return null;

    return getOuterProductCard(target);
  }

  function getCardGallery(card) {
    if (!card) return null;

    return (
      card.querySelector('.card-gallery') ||
      card.querySelector('[ref="cardGallery"]') ||
      card
    );
  }

  function getMainImage(card) {
    if (!card) return null;

    var gallery = getCardGallery(card);
    var scope = gallery || card;

    var images = Array.from(scope.querySelectorAll('img'));
    if (!images.length) return null;

    var visibleImages = images.filter(function (img) {
      var rect = img.getBoundingClientRect();
      var style = window.getComputedStyle(img);

      return (
        rect.width > 40 &&
        rect.height > 40 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0'
      );
    });

    visibleImages.sort(function (a, b) {
      var ar = a.getBoundingClientRect();
      var br = b.getBoundingClientRect();

      return br.width * br.height - ar.width * ar.height;
    });

    return visibleImages[0] || images[0];
  }

  function updatePictureSources(img, url, srcset) {
    if (!img) return;

    var picture = img.closest('picture');
    if (!picture) return;

    picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', srcset || url);

      if (source.hasAttribute('data-srcset')) {
        source.setAttribute('data-srcset', srcset || url);
      }
    });
  }

  function setImage(img, url, srcset, alt) {
    if (!img || !url) return;

    img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('srcset', srcset || url);
    img.setAttribute('data-srcset', srcset || url);

    if (alt) {
      img.setAttribute('alt', alt);
    }

    img.removeAttribute('loading');

    updatePictureSources(img, url, srcset || url);
  }

  function updateCardImage(card, button) {
    if (!card || !button) return;

    var url = button.getAttribute('data-image-url') || '';
    var srcset = button.getAttribute('data-image-srcset') || url;
    var alt =
      button.getAttribute('data-media-alt') ||
      button.getAttribute('data-color-name') ||
      '';

    if (!url) return;

    var img = getMainImage(card);
    if (!img) return;

    setImage(img, url, srcset, alt);
  }

  function paintActiveCircle(card, button) {
    if (!card || !button) return;

    var group = button.closest('.pc-color-squares');
    if (!group) return;

    group.querySelectorAll('.pc-color-square').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.removeAttribute('data-selected');

      var inner = btn.querySelector('.pc-color-square__inner');

      if (inner) {
        inner.style.borderWidth = '1px';
        inner.style.borderColor = 'rgba(0,0,0,0.28)';
        inner.style.boxShadow = '0 1px 2px rgba(0,0,0,0.12)';
        inner.style.transform = 'scale(1)';
      }
    });

    button.classList.add('is-active');
    button.setAttribute('data-selected', 'true');

    var activeInner = button.querySelector('.pc-color-square__inner');

    if (activeInner) {
      activeInner.style.borderWidth = '2px';
      activeInner.style.borderColor = '#ffffff';
      activeInner.style.boxShadow = '0 0 0 2px #7B9194';
      activeInner.style.transform = 'scale(1.05)';
    }
  }

  function updateBadges(card, button) {
    if (!card || !button) return;

    renameLimitedEditionBadges(card);

    var bestSellerWrap = card.querySelector('.pc-best-seller-badge-wrap');
    var limitedEditionWrap = card.querySelector('.pc-limited-edition-badge-wrap');

    /*
      Product-page recommendation cards:
      Hide Best Seller. Keep only New Arrivals, renamed to NEW.
      Main product-page badge area is not touched by this script.
    */
    var showLimitedEdition =
      String(button.getAttribute('data-limited-edition')).toLowerCase() === 'true';

    if (bestSellerWrap) {
      bestSellerWrap.hidden = true;
      bestSellerWrap.style.display = 'none';
    }

    if (limitedEditionWrap) {
      limitedEditionWrap.hidden = !showLimitedEdition;
      limitedEditionWrap.style.display = showLimitedEdition ? '' : 'none';
    }
  }

  function forceAllCardLinks(card, variantUrl) {
    if (!card || !variantUrl) return;

    card.__vavoomSelectedVariantUrl = variantUrl;
    card.setAttribute('data-selected-variant-url', variantUrl);

    /*
      IMPORTANT:
      Your product card has more than one product link:
      1. .product-card__link overlay from product-card.liquid
      2. cardGalleryLink/image link from card-gallery.liquid

      Both must be updated or Shopify can still open the default/first variant.
    */
    card.querySelectorAll('a, .product-card__link, [ref="productCardLink"], [ref="cardGalleryLink"]').forEach(function (link) {
      if (!link) return;
      if (link.closest('form')) return;
      if (link.closest('.quick-add')) return;
      if (link.closest('[class*="quick-add"]')) return;

      if (link.tagName && link.tagName.toLowerCase() === 'a') {
        link.setAttribute('href', variantUrl);
      }

      link.setAttribute('data-selected-variant-url', variantUrl);
      link.setAttribute('data-pc-selected-variant-url', variantUrl);
    });
  }

  function selectButton(card, button) {
    if (!card || !button) return '';

    var variantUrl = button.getAttribute('data-variant-url') || '';

    card.__vavoomSelectedButton = button;
    card.__vavoomSelectedVariantUrl = variantUrl;

    paintActiveCircle(card, button);
    updateCardImage(card, button);
    updateBadges(card, button);
    forceAllCardLinks(card, variantUrl);

    return variantUrl;
  }

  function getSelectedButton(card) {
    if (!card) return null;

    if (card.__vavoomSelectedButton && card.contains(card.__vavoomSelectedButton)) {
      return card.__vavoomSelectedButton;
    }

    return (
      card.querySelector('.pc-color-square.is-active[data-variant-url]') ||
      card.querySelector('.pc-color-square[data-selected="true"][data-variant-url]') ||
      card.querySelector('.pc-color-square[data-swatch-position="1"][data-variant-url]') ||
      card.querySelector('.pc-color-square[data-variant-url]')
    );
  }

  function getSelectedVariantUrl(card) {
    if (!card) return '';

    if (card.__vavoomSelectedVariantUrl) {
      return card.__vavoomSelectedVariantUrl;
    }

    var selected = getSelectedButton(card);

    if (selected) {
      return selected.getAttribute('data-variant-url') || '';
    }

    return card.getAttribute('data-selected-variant-url') || '';
  }

  function getFirstButton(card) {
    if (!card) return null;

    return (
      card.querySelector('.pc-color-square[data-swatch-position="1"][data-variant-url]') ||
      card.querySelector('.pc-color-square[data-variant-url]')
    );
  }

  function resetCardToFirst(card) {
    if (!card || isMobile()) return;

    var first = getFirstButton(card);
    if (!first) return;

    selectButton(card, first);
  }

  function bindCard(card) {
    if (!card || card.__vavoomProductPageRecommendedBoundV72) return;
    card.__vavoomProductPageRecommendedBoundV72 = true;

    renameLimitedEditionBadges(card);

    var first = getFirstButton(card);
    if (first && !card.__vavoomSelectedButton) {
      selectButton(card, first);
    }

    card.addEventListener(
      'mouseleave',
      function () {
        setTimeout(function () {
          if (!card.matches(':hover')) {
            resetCardToFirst(card);
          }
        }, 70);
      },
      true
    );
  }

  function init(scope) {
    var container = scope || document;

    renameLimitedEditionBadges(container);

    container.querySelectorAll('.pc-color-squares').forEach(function (group) {
      if (!isRecommendedArea(group)) return;
      if (isBadArea(group)) return;

      var card = getOuterProductCard(group);
      if (!card) return;

      bindCard(card);
    });
  }

  /*
    Desktop:
    Hover circle = preview selected variant image in the exact recommended card.
  */
  document.addEventListener(
    'mouseover',
    function (event) {
      if (isMobile()) return;
      if (!isElement(event.target)) return;

      var button = event.target.closest('.pc-color-square[data-variant-url]');
      if (!button) return;
      if (!isRecommendedArea(button)) return;
      if (isBadArea(button)) return;

      var card = getCardFromButton(button);
      if (!card) return;

      bindCard(card);
      selectButton(card, button);
    },
    true
  );

  /*
    Pointerdown:
    Runs before Shopify's normal product-card click behavior.
    This updates all hrefs early.
  */
  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!isElement(event.target)) return;
      if (!isRecommendedArea(event.target)) return;
      if (isBadArea(event.target)) return;

      var circle = event.target.closest('.pc-color-square[data-variant-url]');
      var card = circle ? getCardFromButton(circle) : getCardFromTarget(event.target);
      if (!card) return;

      var variantUrl = '';

      if (circle) {
        variantUrl = circle.getAttribute('data-variant-url') || '';
        card.__vavoomSelectedButton = circle;
      } else {
        variantUrl = getSelectedVariantUrl(card);
      }

      if (!variantUrl) return;

      forceAllCardLinks(card, variantUrl);
    },
    true
  );

  /*
    Click:
    - Desktop circle click opens the clicked variant.
    - Mobile first tap previews, second tap same circle opens.
    - Product image/card link opens currently selected variant.
  */
  document.addEventListener(
    'click',
    function (event) {
      if (!isElement(event.target)) return;
      if (!isRecommendedArea(event.target)) return;
      if (isBadArea(event.target)) return;

      var circle = event.target.closest('.pc-color-square[data-variant-url]');
      var productClick =
        circle ||
        event.target.closest('a[href*="/products/"], .product-card__link, [ref="productCardLink"], [ref="cardGalleryLink"], img, picture');

      if (!productClick) return;

      var card = circle ? getCardFromButton(circle) : getCardFromTarget(productClick);
      if (!card) return;

      bindCard(card);

      var variantUrl = '';

      if (circle) {
        variantUrl = selectButton(card, circle);
      } else {
        variantUrl = getSelectedVariantUrl(card);
      }

      if (!variantUrl) return;

      forceAllCardLinks(card, variantUrl);

      if (circle && isMobile()) {
        var sameButton = card.__vavoomMobileArmedButton === circle;
        card.__vavoomMobileArmedButton = circle;

        setTimeout(function () {
          selectButton(card, circle);
          forceAllCardLinks(card, variantUrl);
        }, 100);

        setTimeout(function () {
          selectButton(card, circle);
          forceAllCardLinks(card, variantUrl);
        }, 240);

        if (!sameButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.href = variantUrl;

      return false;
    },
    true
  );

  function startObserver() {
    if (window.__VAVOOM_RECOMMENDED_CARD_SWATCHES_PRODUCT_PAGE_ONLY_OBSERVER_V72__) return;
    window.__VAVOOM_RECOMMENDED_CARD_SWATCHES_PRODUCT_PAGE_ONLY_OBSERVER_V72__ = true;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          renameLimitedEditionBadges(node);

          if (node.matches && node.matches('.pc-color-squares')) {
            init(node.parentNode || document);
            return;
          }

          if (node.querySelector && node.querySelector('.pc-color-squares')) {
            init(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('theme:section-morphed', function (event) {
    var container = event.detail && event.detail.container ? event.detail.container : document;
    init(container);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      startObserver();
    });
  } else {
    init(document);
    startObserver();
  }
})();